'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Jobs;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Job = require('./Job');

var _Job2 = _interopRequireDefault(_Job);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'jobs';

var getContent = function getContent(params) {
  var jobs = params.jobs,
      loading = params.loading,
      jobLimit = params.jobLimit;


  if (loading) {
    return _react2.default.createElement(
      'p',
      null,
      'Loading jobs'
    );
  } else if (!jobs.length) {
    return _react2.default.createElement(
      'p',
      null,
      'No jobs were found that match; please try again.'
    );
  }

  var limitedJobs = jobs.slice(0, jobLimit);

  return _react2.default.createElement(
    'div',
    { className: CLASS_NAME + '-list' },
    _react2.default.createElement(
      'h2',
      null,
      _react2.default.createElement(
        'span',
        { className: 'mobile-only' },
        'My Matches'
      )
    ),
    limitedJobs.map(function (_ref, key) {
      var matches = _ref.matches,
          title = _ref.title,
          content = _ref.content,
          subsectors = _ref.subsectors,
          interests = _ref.interests,
          skills = _ref.skills,
          education = _ref.education,
          fullSlug = _ref.fullSlug;
      return _react2.default.createElement(_Job2.default, {
        key: key,
        matches: matches,

        fullSlug: fullSlug,
        title: title,
        content: content,
        subsectors: subsectors,

        interests: interests,
        skills: skills,
        education: education
      });
    })
  );
};

function Jobs(props) {
  return _react2.default.createElement(
    'div',
    {
      className: CLASS_NAME
    },
    getContent(props)
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Matcher/components/Jobs/Jobs.jsx
// module id = 1235
// module chunks = 0